import Bill from './Bill'
import Model from './BaseModel'
import BillInstallment from './BillInstallment'

export default class BillNegotiation extends Model {
    resourceName() {
        return 'bill-negotiation'
    }

    fields() {
        return ['id', 'installments', 'bill_id']
    }

    relationships() {
        return {
            bill: new Bill(),
            billInstallments: new BillInstallment(),
        }
    }
}
